<template>
  <div class="ui-banner" :class="[tone !== 'bad' && `ui-banner--${tone}`, lg && 'ui-banner--lg']" :role="role">
    <v-icon size="16" color="currentColor">{{ iconName }}</v-icon>
    <span><slot></slot></span>
  </div>
</template>

<script>
const ICONS = { bad: "mdi-alert-outline", warn: "mdi-alert-outline", info: "mdi-information-outline" };

/** Obavijest: tone bad (crveno) | warn | info; lg je veća i uokvirena (npr. greška učitavanja sa dugmetom); role status (zadano) ili alert za greške. */
export default {
  name: "UiBanner",
  props: {
    tone: { type: String, default: "bad" },
    icon: { type: String, default: "" },
    role: { type: String, default: "status" },
    lg: { type: Boolean, default: false },
  },
  computed: {
    iconName() {
      return this.icon || ICONS[this.tone];
    },
  },
};
</script>
